import React, { useEffect, useRef, useState } from "react";
import "./bulkImport.css";
import Select from "react-select";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { bulkImageImportApi, bulkImportApi } from "../../../../services/apis/BulkImportApi";
import BtnLoader from "../../../components/Loader/btnLoader";
import {
  isMobile,
  isTablet,
  isDesktop,
  isAndroid,
  isIOS,
} from "react-device-detect";
import { CreatelogActivityApi } from "../../../../services/apis/IpAddress";
import { useSelector } from "react-redux";
import { Toaster } from "../../../components/Toaster/Toster";
import { ToastContainer } from "react-toastify";
// import axios from "axios";

const BulkImport = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedThread, setSelectedThread] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [uploadedExcel, setUploadedExcel] = useState(null);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [fileBtnLoading,setFileBtnLoading]=useState(false);
  const [imgBtnLoading,setImgBtnLoading]=useState(false);
  const user = useSelector((data)=>data?.userReducers?.user);
  const fileExcelRef = useRef(null); 
  const fileInputRef = useRef(null); 

  // console.log("uploadedImages",uploadedImages)

  const informationIp = useSelector(
    (data) => data?.ipAddressReducers?.ipAddressData
  );
  const deviceType = {
    type: isMobile
      ? "Mobile"
      : isTablet
      ? "Tablet"
      : isDesktop
      ? "Desktop"
      : "Unknown",
    os: isAndroid ? "Android" : isIOS ? "iOS" : "Other",
  };

  const showToaster = (message) => {
    // Implement a toaster mechanism, e.g., a library like react-toastify, or your custom toaster component
    alert(message); // Replace with a proper toaster function
  };

  const handleDrop = (e, fileType) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    handleFiles(files, fileType);
  };

  const handleFileChange = (e, fileType) => {
    const files = e.target.files ? Array.from(e.target.files) : [];
    if (files.length === 0) {
      setErrorMessage("No files selected.");
      return;
    }
    handleFiles(files, fileType);
    // const files = Array.from(e.target.files);
    // handleFiles(files, fileType);
  };

  const handleFiles = (files, fileType) => {
    const maxFileSize = 20 * 1024 * 1024; // 20MB in bytes
    const validImageTypes = ["image/jpeg", "image/png", "image/gif"];
    const validExcelTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
    ];
    let error = "";

    if (fileType === "excel") {
      const file = files[0]; // Only allow one Excel file
      if (!validExcelTypes.includes(file.type)) {
        error = `File "${file.name}" is not a valid Excel format.`;
      } else {
        setUploadedExcel(file);
      }
    } else if (fileType === "image") {
      const validFiles = [];
      files.forEach((file) => {
        if (file.size > maxFileSize) {
          showToaster(`File "${file.name}" exceeds the 20MB size limit.`);
        } else if (!validImageTypes.includes(file.type)) {
          error = `File "${file.name}" is not a valid image format.`;
        } else {
          validFiles.push(file);
        }
      });
      setUploadedImages((prevFiles) => [...prevFiles, ...validFiles]);
    }

    if (error) {
      setErrorMessage(error);
    } else {
      setErrorMessage("");
    }
  };

  const handleReset = (fileType) => {
    if (fileType === "excel") {
      setUploadedExcel(null);
      if (fileExcelRef.current) {
        fileExcelRef.current.value = ""; // Reset the file input value
      }
    } else if (fileType === "image") {
      setUploadedImages([]);
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Reset the file input value
      }
    }
    setErrorMessage("");
  };

  useEffect(() => {
    setSelectedThread(null);
  }, []);

  const theadData = [
    // { heading: "Business Card Url", value:"business_card_url",},
    { heading: "Member Id", value: "member_id" },
    { heading: "User Type", value: "user_type" },
    { heading: "Name", value: "member_name" },
    { heading: "Email", value: "email" },
    { heading: "Mobile", value: "mobile" },
    { heading: "WhatsApp No", value: "whatsapp_number" },
    { heading: "City", value: "city" },
    { heading: "Zone", value: "zone" },
  ];

  const handleDownload = (withSampleData) => {
    // Step 1: Prepare headers
    const headers = theadData?.map((col) => col?.value);
    let data = [];
    if (withSampleData) {
      data = [
        [
          1234,
          "ICAI",
          "Dummy Name",
          "dummy@example.com",
          "+919876543210",
          "+919876543210",
          "Udaipur",
          "WRO",
        ],
        [
          4321,
          "ICAI",
          "Another Dummy",
          "another@example.com",
          "+919876543210",
          "+919876543210",
          "Ajmer",
          "SRO",
        ],
      ];
    } else {
      // Set dummy data for "Without Any Data"
      data = [];
    }
    // Step 3: Combine headers and data
    const worksheetData = [headers, ...data];
    // Step 4: Create a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    // Step 5: Create a workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Template");
    // Step 6: Trigger file download
    XLSX.writeFile(
      workbook,
      `Template_${withSampleData ? "Sample" : "Dummy"}.xlsx`
    );
  };

  const loggedActivity = async (logType) => {
    const data = {
      id:user?._id,
      ipAddress: informationIp?.query,
      lat: informationIp?.lat,
      long: informationIp?.lon,
      logType: logType,
      deviceType: JSON.stringify(deviceType),
      city: informationIp?.city,
      countryCode: informationIp?.countryCode,
      regionCode: informationIp?.region,
    };
    try {
      await CreatelogActivityApi(data);
    } catch (err) {
      console.log(err);
    }
  };

  // Handle file submission
  // const handleSubmit = async () => {
  //   if (!uploadedFile) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "No File Selected",
  //       text: "Please upload a file before submitting.",
  //     });
  //     return;
  //   }

  //   setBtnLoading(true);
  //   try {
  //       const response = await bulkImportApi(uploadedFile);
  //       console.log("Bulk import response:", response);

  //     if (response?.data?.success) {
  //       Swal.fire({
  //         icon: "success",
  //         title: "Import Successful",
  //         text: response?.data?.message || "Your data has been imported successfully!",
  //       });
  //       setUploadedFile(null); // Reset file input
  //       loggedActivity()
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Import Failed",
  //         text: response?.data?.message || "Something went wrong. Please try again.",
  //       });
  //     }
  //   } catch (error) {
  //     //console.error("Error importing file:", error);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Import Failed",
  //       text: error.response?.data?.message || "Something went wrong. Please try again.",
  //     });
  //   }finally{
  //     setBtnLoading(false);
  //   }
  // };

  const handleSubmit = async (fileType) => {
    let fileToUpload = null;
    let errorMessage = "";

    if (fileType === "excel" && !uploadedExcel) {
      errorMessage = "Please upload an Excel file before submitting.";
    } else if (fileType === "image" && uploadedImages.length === 0) {
      errorMessage = "Please upload at least one image file before submitting.";
    }

    if (errorMessage) {
      Swal.fire({
        icon: "error",
        title: "No File Selected",
        text: errorMessage,
      });
      return;
    }

    setBtnLoading(true);
    try {
      // For Excel upload
      if (fileType === "excel") {
        fileToUpload = uploadedExcel;
        setFileBtnLoading(true);
      try{
        const response = await bulkImportApi(fileToUpload);
        if (response?.data?.success) {
          Swal.fire({
            icon: "success",
            title: "Import Successful",
            text:
              response?.data?.message ||
              "Your data has been imported successfully!",
          });
          setUploadedExcel(null); // Reset file input
          loggedActivity("import");
        } else {
          Swal.fire({
            icon: "error",
            title: "Import Failed",
            text:
              response?.data?.message ||
              "Something went wrong. Please try again.",
          });
        }
      }catch(err){
       console.log(err) 
       Toaster.error(err?.response?.data?.message);
      }finally{
        setFileBtnLoading(false);
      }
      }

      // For Image upload
      if (fileType === "image") {
        setImgBtnLoading(true);
        try{
        const response = await bulkImageImportApi(uploadedImages);
        // console.log("Image upload response:", response);
        if (response?.data?.success) {
          Swal.fire({
            icon: "success",
            title: "Image Upload Successful",
            text:
              response?.data?.message ||
              "Your images have been uploaded successfully!",
          });
          setUploadedImages([]); // Reset image files
          loggedActivity("importimage");
        } else {
          Swal.fire({
            icon: "error",
            title: "Image Upload Failed",
            text:
              response?.data?.message ||
              "Something went wrong. Please try again.",
          });
        }
      }catch(err){
        console.log(err);
        Toaster.error(err?.response?.data?.message);
      }finally{
        setImgBtnLoading(false);
      }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text:
          error.response?.data?.message ||
          "Something went wrong. Please try again.",
      });
    } finally {
      setBtnLoading(false);
    }
  };

  return (<>
     <ToastContainer />
    <div className="bulkcontainer">
      <h1 className="title">Bulk Import</h1>

      <div className="download-section">
        <h2 className="upload-title">Download Template</h2>

        <div className="download-buttons-section">
          <p className="download-title">Download Spreadsheet Template</p>
          <div className="download-buttons">
            <button
              className="btn btn btn-outline-danger"
              onClick={() => handleDownload(true)}>
              With Sample Data
            </button>
            <button
              className="btn btn-primary"
              onClick={() => handleDownload(false)}>
              Without Any Data
            </button>
          </div>
        </div>
      </div>

      {/* Excel File Upload */}
      {/* <div className="upload-section">
        <h2 className="upload-title">Excel File Upload</h2>
        <div
          className="file-dropzone"
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onClick={() => document.getElementById('file-input').click()}
          style={{
            border: '2px dashed #ccc',
            padding: '20px',
            textAlign: 'center',
            cursor: 'pointer',
          }}>
          <p>
            Drag and drop your Excel file here, or click to select a file.
            <br />
            Must be Excel files using our Excel template above.
          </p>
          <input
            id="file-input"
            type="file"
            accept=".xls,.xlsx,.csv"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </div>
        {uploadedFile && <p style={{ marginTop: '10px' }}>Uploaded File: {uploadedFile.name}</p>}
        <div className="action-buttons" style={{ marginTop: '20px' }}>
          <button
            className="btn reset"
            onClick={() => setUploadedFile(null)}>
            Reset
          </button>
          <button
            className="btn secondary"
            disabled={!uploadedFile}
            onClick={handleSubmit}>
            {btnLoading && <BtnLoader/>} Submit
          </button>
        </div>
      </div> */}

      <div>
        {/* Excel File Upload */}
        <div className="upload-section">
          <h2 className="upload-title">Excel File Upload</h2>
          <div
            className="file-dropzone"
            onDrop={(e) => handleDrop(e, "excel")}
            onDragOver={(e) => e.preventDefault()}
            onClick={() => document.getElementById("excel-input").click()}
            style={{
              border: "2px dashed #ccc",
              padding: "20px",
              textAlign: "center",
              cursor: "pointer",
            }}>
            <p>
              Drag and drop your Excel file here, or click to select a file.
              <br />
              Must be Excel files using our Excel template above.
            </p>
            <input
              id="excel-input"
              ref={fileExcelRef}
              type="file"
              accept=".xls,.xlsx,.csv"
              style={{ display: "none" }}
              onChange={(e) => handleFileChange(e, "excel")}
            />
          </div>
          {uploadedExcel && (
            <p style={{ marginTop: "10px" }}>
              Uploaded File: {uploadedExcel.name}
            </p>
          )}
          <div className="action-buttons" style={{ marginTop: "20px" }}>
            <button className="btn reset" onClick={() => handleReset("excel")}>
              Reset
            </button>
            <button
              className="btn secondary"
              disabled={!uploadedExcel}
              onClick={() => handleSubmit("excel")}>
              {
                fileBtnLoading && <BtnLoader/>
              }
              Submit
            </button>
          </div>
        </div>

        {/* Image Upload */}
        <div className="upload-section" style={{ marginTop: "40px" }}>
          <h2 className="upload-title">Image Upload</h2>
          <div
            className="file-dropzone"
            onDrop={(e) => handleDrop(e, "image")}
            onDragOver={(e) => e.preventDefault()}
            onClick={() => document.getElementById("image-input").click()}
            style={{
              border: "2px dashed #ccc",
              padding: "20px",
              textAlign: "center",
              cursor: "pointer",
            }}>
            <p>
              Drag and drop your images here, or click to select files.
              <br />
              Only image files (.jpg, .png, .gif) up to 20MB are allowed.
            </p>
            <input
              ref={fileInputRef}
              id="image-input"
              type="file"
              accept="image/jpeg,image/png,image/gif"
              multiple
              style={{ display: "none" }}
              onChange={(e) => handleFileChange(e, "image")}
            />
          </div>
          {errorMessage && (
            <p style={{ color: "red", marginTop: "10px" }}>{errorMessage}</p>
          )}
          {uploadedImages?.length > 0 && (
            <div style={{ marginTop: "10px" }}>
              <p>Uploaded Files:</p>
              
              <ul className="images-title-main-div">
                {uploadedImages?.map((file, index) => (
                  <div className="images-title-div" key={index}>
                    <li>{file.name}</li>
                  </div>
                ))}
              </ul>
            </div>
          )}
          <div className="action-buttons" style={{ marginTop: "20px" }}>
            <button className="btn reset" onClick={() => handleReset("image")}>
              Reset
            </button>
            <button
              className="btn secondary"
              disabled={uploadedImages?.length === 0}
              onClick={() => handleSubmit("image")}>
              {
                imgBtnLoading && <BtnLoader/>
              }
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default BulkImport;

//Second Last
// import React, { useState } from "react";
// import "./BulkImport.css";
// import Select from "react-select";
// import * as XLSX from "xlsx";

// const fittingThreadOptions = [
//   { value: "BSP", label: "BSP (B)", code: "B", dsc_code: "BSP" },
//   { value: "BSP O", label: "BSP ORING (BO)", code: "BO", dsc_code: "BSPO" },
//   { value: "JIC", label: "JIC (J)", code: "J", dsc_code: "JIC" },
//   { value: "ORFS", label: "ORFS (O)", code: "O", dsc_code: "ORFS" },
//   { value: "KOMATSU", label: "KOMATSU (K)", code: "K", dsc_code: "KOMATSU" },
//   { value: "METRIC", label: "METRIC", code: "M", dsc_code: "M" },
//   { value: "NPT", label: "NPT (NPT)", code: "NPT", dsc_code: "NPT" },
//   { value: "JIS", label: "JIS (BSP C-TYPE) (BJ)", code: "BJ", dsc_code: "JIS" },
//   { value: "SAE 61", label: "FLG CODE 61- 3000 PSI (3)", code: "3", dsc_code: "JIS" },
//   { value: "SAE 62", label: "FLG CODE 62- 6000 PSI (6)", code: "6", dsc_code: "FLG61" },
//   { value: "BANJO WITHOUT O", label: "BANJO WITHOUT O (BJ)", code: "BJ", dsc_code: "FLG62" },
//   { value: "BANJO WITH O", label: "BANJO WITH O (BJO)", code: "BJO", dsc_code: "BANJO" },
//   { value: "METRIC THREAD ORFS", label: "METRIC THREAD ORFS (MO)", code: "MO", dsc_code: "M-ORFS" }
// ];

// const ProductOptions = [
//   { value: "End Fittings", label: "End Fittings" },
//   { value: "Hose Pipe", label: "Hose Pipe" },
//   { value: "Hose Assembly", label: "Hose Assembly" },
//   { value: "Spring", label: "Spring" },
//   { value: "O-ring", label: "O-ring" },
//   { value: "Dust Cap", label: "Dust Cap" },
//   { value: "Sleeve", label: "Sleeve" },
//   { value: "Vinyl Cover", label: "Vinyl Cover" },
//   { value: "Packing", label: "Packing" },
//   { value: "Tube Fittings", label: "Tube Fittings" },
// ];

// const BulkImport = () => {
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [errors, setErrors] = useState('');

//   return (
//     <div className="container">
//       <h1 className="title">Bulk Import</h1>
//       <div className="steps-grid">
//         {/* Step 1 */}
//     <div className="step-card">
//       <div className="d-flex align-items-center justify-content-between">
//         <h2 className="step-title">Step 1</h2>
//         <img
//           src="https://restaurant.idea2reality.tech/public/assets/admin/img/bulk1.png"
//           alt="Logo"
//           style={{ width: '50px', height: '50px' }}
//         />
//       </div>
//       <p className="step-subtitle">Download The Excel File</p>
//       <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: 0 }}>
//         <li>Select Product.</li>
//         <li>Select Product Fitting Type Like BSP, JIS, M ..etc</li>
//         <li>Download the format file and fill it with proper data.</li>
//         <li>Download the example file to understand how the data must be filled.</li>
//         <li>Upload the Excel file.</li>
//       </ul>
//     </div>

//     {/* Step 2 */}
//     <div className="step-card">
//       <h2 className="step-title">Step 2</h2>
//       <p className="step-subtitle">Match Spreadsheet Data According To Instruction</p>
//       <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: 0 }}>
//         <li>Fill up the data according to the format.</li>
//         <li>You can get the restaurant ID; input the correct IDs.</li>
//       </ul>
//     </div>

//     {/* Step 3 */}
//     <div className="step-card">
//       <h2 className="step-title">Step 3</h2>
//       <p className="step-subtitle">Validate Data And Complete Import</p>
//       <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: 0 }}>
//         <li>Select the upload option in the Excel file upload section.</li>
//         <li>Upload your file in .xls or .xlsx format.</li>
//         <li>Click the upload button.</li>
//       </ul>
//     </div>
//   </div>

//       <div className="download-section">
//         <h2 className="upload-title">Download Template</h2>
//         <div className="row">
//           <div className="col-md-4">
//             <label className="col-form-label">Select Product</label>
//             <Select
//               value={selectedProduct}
//               onChange={(option) => setSelectedProduct(option)}
//               options={ProductOptions}
//               placeholder="Select Product"
//               styles={{
//                 control: (provided) => ({
//                   ...provided,

//                   color: '#7e7e7e',
//                   paddingLeft: '15px',
//                 }),
//               }}
//             />
//             {errors && <span className="text-danger fs-12">{errors}</span>}
//           </div>

//           {selectedProduct?.value === "End Fittings" && (
//             <div className="col-md-4">
//               <label className="col-form-label">Select Fitting Thread Type</label>
//               <Select
//                 options={fittingThreadOptions}
//                 placeholder="Select Fitting Thread"
//                 styles={{
//                   control: (provided) => ({
//                     ...provided,

//                     color: '#7e7e7e',
//                     paddingLeft: '15px',
//                   }),
//                 }}
//               />
//             </div>
//           )}
//         </div>

//         <div className="download-buttons-section">
//           <p className="download-title">Download Spreadsheet Template</p>
//           <div className="download-buttons">
//             <button className="btn primary">With Sample Data</button>
//             <button className="btn secondary">Without Any Data</button>
//           </div>
//         </div>
//       </div>

//       {/* File Upload Section */}
//       <div className="upload-section">
//         <h2 className="upload-title">Excel File Upload</h2>
//         <div className="file-dropzone">
//           <p>Must be Excel files using our Excel template above</p>
//         </div>
//         <div className="action-buttons">
//           <button className="btn reset">Reset</button>
//           <button className="btn import">Import</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BulkImport;

// import React from "react";
// import "./BulkImport.css";
// import Select from "react-select";

// const BulkImport = () => {
//     let errors = '';
//     return (
//         <div className="container">
//             <h1 className="title">Bulk Import</h1>
// <div className="steps-grid">
//     {/* Step 1 */}
//     <div className="step-card">
//         <div className="d-flex align-items-center justify-content-between">
//             <h2 className="step-title">Step 1</h2>
//             <img
//                 src="https://restaurant.idea2reality.tech/public/assets/admin/img/bulk1.png"
//                 alt="Logo"
//                 style={{ width: '50px', height: '50px' }}
//             />
//         </div>
//         <p className="step-subtitle">Download The Excel File</p>
//         <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: 0 }}>
//             <li style={{ listStyleType: 'disc' }}>Select Product.</li>
//             <li style={{ listStyleType: 'disc' }}>Select Product Fitting Type Like BSP, JIS, M ..etc</li>
//             <li style={{ listStyleType: 'disc' }}>Download the format file and fill it with proper data.</li>
//             <li style={{ listStyleType: 'disc' }}>Download the example file to understand how the data must be filled.</li>
//             <li style={{ listStyleType: 'disc' }}>Upload the Excel file.</li>
//         </ul>
//     </div>

//     {/* Step 2 */}
//     <div className="step-card">
//         <h2 className="step-title">Step 2</h2>
//         <p className="step-subtitle">Match Spreadsheet Data According To Instruction</p>
//         <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: 0 }}>
//             <li style={{ listStyleType: 'disc' }}>Fill up the data according to the format.</li>
//             <li style={{ listStyleType: 'disc' }}>You can get the restaurant ID; input the correct IDs.</li>
//         </ul>
//     </div>
//     {/* Step 3 */}
//     <div className="step-card">
//         <h2 className="step-title">Step 3</h2>
//         <p className="step-subtitle">Validate Data And Complete Import</p>
//         <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: 0 }}>
//             <li style={{ listStyleType: 'disc' }}>Select the upload option in the Excel file upload section.</li>
//             <li style={{ listStyleType: 'disc' }}>Upload your file in .xls or .xlsx format.</li>
//             <li style={{ listStyleType: 'disc' }}>Click the upload button.</li>
//         </ul>
//     </div>
// </div>

//             <div className="download-section">
//                 <h2 className="upload-title">Download Template</h2>

//                 <div className="row">
//                     <div className="col-md-4">
//                         <label className="col-form-label">Select Product</label>
//                         {/* <label className="col-form-label" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
//                       With Cap / Without Cap
//                     </label> */}
//                         <Select
//                             value={"selectedWithCapWithoutCapOption"}
//                             onChange={(option) => {
//                                 // setSelectedWithCapWithoutCapOption(option);
//                                 // setFormData({
//                                 //   ...formData,
//                                 //   with_cap: option.value,
//                                 // });
//                             }}
//                             defaultValue={"selectedWithCapWithoutCapOption"}
//                             options={"withCapWithoutCapOption"}
//                             style={{
//                                 lineHeight: "40px",
//                                 color: "#7e7e7e",
//                                 paddingLeft: " 15px",
//                             }}
//                         />
//                         {errors.with_cap && (
//                             <span className="text-danger fs-12">
//                                 {errors.with_cap}
//                             </span>
//                         )}
//                     </div>

//                     <div className="col-md-4">
//                         <label className="col-form-label">Select Fitting Thread Type</label>
//                         {/* <label className="col-form-label" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
//                       With Cap / Without Cap
//                     </label> */}
//                         <Select
//                             value={"selectedWithCapWithoutCapOption"}
//                             onChange={(option) => {
//                                 // setSelectedWithCapWithoutCapOption(option);
//                                 // setFormData({
//                                 //   ...formData,
//                                 //   with_cap: option.value,
//                                 // });
//                             }}
//                             defaultValue={"selectedWithCapWithoutCapOption"}
//                             options={"withCapWithoutCapOption"}
//                             style={{
//                                 lineHeight: "40px",
//                                 color: "#7e7e7e",
//                                 paddingLeft: " 15px",
//                             }}
//                         />
//                         {errors.with_cap && (
//                             <span className="text-danger fs-12">
//                                 {errors.with_cap}
//                             </span>
//                         )}
//                     </div>
//                 </div>

//                 <div className="download-buttons-section">
//                     <p className="download-title">Download Spreadsheet Template</p>
//                     <div className="download-buttons">
//                         <button className="btn primary">With Sample Data</button>
//                         <button className="btn secondary">Without Any Data</button>
//                     </div>
//                 </div>

//             </div>

//             {/* File Upload Section */}
//             <div className="upload-section">
//                 <h2 className="upload-title">Excel File Upload</h2>
//                 {/* <div className="radio-group">
//                     <label className="radio-option">
//                         <input type="radio" name="uploadType" value="new" />
//                         Upload New Data
//                     </label>
//                     <label className="radio-option">
//                         <input type="radio" name="uploadType" value="update" />
//                         Update Existing Data
//                     </label>
//                 </div> */}
//                 <div className="file-dropzone">
//                     <p>Must be Excel files using our Excel template above</p>
//                 </div>
//                 <div className="action-buttons">
//                     <button className="btn reset">Reset</button>
//                     <button className="btn import">Import</button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default BulkImport;
